export const headers = [
  { content: "Plan" },
  { content: "Functional Area" },
  { content: "Source" },
  { content: "Properties" },
  { content: "" }
];
